<div class="modal-container">
  <h2 mat-dialog-title>{{ 'EMAIL_BUILDER.CONTEXT_SELECTOR.CONTACT_SELECTOR.PREVIEW_AS' | translate }}</h2>
  <div class="search-container">
    <glxy-form-field suffixIcon="search">
      <input
        matInput
        type="text"
        placeholder="{{ 'EMAIL_BUILDER.CONTEXT_SELECTOR.CONTACT_SELECTOR.SEARCH' | translate }}"
        [formControl]="contactSearchFormField"
      />
    </glxy-form-field>
  </div>

  <mat-dialog-content class="options-container">
    @if (contacts(); as contacts) {
      @for (contact of contacts; track contact) {
        <div class="option" (click)="selectContact(contact)">
          <div class="option-title">
            {{ contact.name }}
          </div>
          <div class="option-subtitle">
            {{ contact.email }}
          </div>
        </div>
      }
      @if (hasMore()) {
        <glxy-infinite-scroll-trigger (isVisible)="loadMoreContacts()"></glxy-infinite-scroll-trigger>
      }
      @if (loading()) {
        <div class="stencil-shimmer loading-shimmer"></div>
      } @else if (contacts.length === 0) {
        <div class="empty">
          {{ 'EMAIL_BUILDER.CONTEXT_SELECTOR.CONTACT_SELECTOR.NO_CONTACTS_FOUND' | translate }}
        </div>
      }
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button (click)="cancel()">{{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}</button>
  </mat-dialog-actions>
</div>
